<sm-table *ngIf="inited" [data]="table" (onRowSelect)="selectRow($event)">
</sm-table>
